import React, { useState, useEffect, useContext } from 'react';
import styled from 'styled-components';
import { useNavigate, useParams } from 'react-router-dom'; // ✅ import useParams
import { AppContext } from '../context/AppContext';
import { getUpsellOptions } from '../api/vehicleAPI';
import Container from '../components/common/Container';
import OrderSummary from '../components/pagamento/OrderSummary';
import PaymentForm from '../components/pagamento/PaymentForm';
import SupportSection from '../components/pagamento/SupportSection';
import Loader from '../components/common/Loader';

const PageWrapper = styled.div`
  padding: 120px 0 60px;
`;

const PaymentLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  align-items: flex-start;

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    grid-template-columns: 1fr;
  }
`;

const PagamentoPage = () => {
  const navigate = useNavigate();
  const { vehicleQuery } = useContext(AppContext);
  const { orderId } = useParams(); 
  const [upsellOptions, setUpsellOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!vehicleQuery) {
      navigate('/');
    }
  }, [vehicleQuery, navigate]);

  useEffect(() => {
    const fetchOptions = async () => {
      setLoading(true);
      const options = await getUpsellOptions();
      setUpsellOptions(options);
      setLoading(false);
    };
    fetchOptions();
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <Container>
      <PageWrapper>
        <PaymentLayout>
          <OrderSummary upsellOptions={upsellOptions} orderId={orderId} />
          <PaymentForm orderId={orderId} />
        </PaymentLayout>
        <SupportSection />
      </PageWrapper>
    </Container>
  );
};

export default PagamentoPage;
